export default __webpack_public_path__ + "static/media/archi_view4_b.8ba909b8.webp";